export default "__VITE_ASSET__D9KdBJlp__"